var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { value: _vm.open },
      on: {
        input: function($event) {
          return _vm.handleEscape()
        }
      },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function() {
            return [
              _c("app-nav-header", {
                attrs: { "show-back": _vm.showBack, search: _vm.search },
                on: {
                  close: function($event) {
                    return _vm.close()
                  },
                  back: function($event) {
                    return _vm.back()
                  },
                  "close-search": function($event) {
                    return _vm.$emit("close-search")
                  },
                  "open-search": function($event) {
                    return _vm.$emit("open-search")
                  }
                }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _vm._v(" "),
      _c(
        "transition",
        {
          attrs: {
            name: _vm.noAnimation ? "animation-disabled" : "fade",
            mode: "out-in"
          }
        },
        [
          _vm.search
            ? _c("app-search")
            : _c("app-nav-list", {
                attrs: { current: _vm.current },
                on: {
                  navigate: function($event) {
                    return _vm.navigate($event)
                  }
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c("lang-select", {
        staticClass: "d-md-none lang-select--mobile",
        attrs: { disableFocus: "" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }